import { img_logo_L, img_logo_S, img_marathon_L, img_marathon_S } from 'components/base/images';
import { IIndicationOptionUi } from 'lib/types/clinic/projectTypes';

export const indicationOptionList = {
  checkbox: [
    {
      title: 'PROJECT_OPTION_SCAN_TYPE',
      list: [
        {
          key: 'situScan',
          title: 'PROJECT_OPTION_SCAN_PRE_OP',
        },
        {
          key: 'separateGingivaScan',
          title: 'PROJECT_OPTION_SCAN_GINGIVA',
        },
      ],
      isPhotogrammetry: false,
    },
    // {
    //   title: 'PROJECT_OPTION_UPPER_JAW',
    //   list: [
    //     {
    //       key: 'situScanUpper',
    //       title: 'PROJECT_OPTION_SCAN_PRE_OP',
    //     },
    //   ],
    //   isPhotogrammetry: true,
    // },
    // {
    //   title: 'PROJECT_OPTION_LOWER_JAW',
    //   list: [
    //     {
    //       key: 'situScanLower',
    //       title: 'PROJECT_OPTION_SCAN_PRE_OP',
    //     },
    //   ],
    //   isPhotogrammetry: true,
    // },
  ],
  dropdown: [
    {
      key: 'materialProstheticGingiva',
      title: 'OPTION_MATERIAL_PROSTHETIC_GINGIVA',
    },
    {
      key: 'materialProstheticTooth',
      title: 'OPTION_MATERIAL_PROSTHETIC_TOOTH',
    },
    {
      key: 'materialProstheticMonoblock',
      title: 'OPTION_MATERIAL_PROSTHETIC_MONOBLOCK',
    },
  ],
  radio: [
    {
      key: 'waxupScan',
      title: 'OPTION_WAXUP_SCAN',
    },
    {
      key: 'aestheticPlateScan',
      title: 'OPTION_AESTHETIC_PLATE_SCAN',
    },
    {
      key: 'virtualGingiva',
      title: 'OPTION_VIRTUAL_GINGIVA',
    },
    {
      key: 'virtualExtractionOrCopyInWizardMode',
      title: 'OPTION_VIRTUAL_EXTRACTION_OR_COPY_IN_WIZARD_MODE',
    },
    {
      key: 'thimbleCrown',
      title: 'OPTION_THIMBLE_CROWN',
    },
    {
      key: 'cervicalAdaption',
      title: 'OPTION_CERVICAL_ADAPTION',
    },
    {
      key: 'biteSplintToothMode',
      title: 'OPTION_BITE_SPLINT_TOOTH_MODE',
    },
    {
      key: 'prostheticToothScalingMode',
      title: 'OPTION_PROSTHETIC_TOOTH_SCALING_MODE',
    },
    {
      key: 'prostheticMonoblockMode',
      title: 'OPTION_PROSTHETIC_MONOBLOCK_MODE',
    },

    {
      key: 'connectorShapeType',
      title: 'OPTION_CONNECTOR_SHAPE_TYPE',
    },
    {
      key: 'connectorUseWidthAndHeightInsteadOfArea',
      title: 'OPTION_CONNECTOR_USE_WIDTH_AND_HEIGHT_INSTEAD_OF_AREA',
    },

    {
      key: 'partialMCStipplePattern',
      title: 'OPTION_PARTIAL_MC_STIPPLE_PATTERN',
    },
    {
      key: 'partialMeshProfile',
      title: 'OPTION_PARTIAL_MESH_PROFILE',
    },
  ],
  slider: [
    {
      key: 'gapWidthCement',
      title: 'OPTION_GAP_WIDTH_CEMENT',
    },
    {
      key: 'minimalTickness',
      title: 'OPTION_MINIMAL_TICKNESS',
    },
    {
      key: 'shrinking',
      title: 'OPTION_SHRINKING',
    },
    {
      key: 'shrinkingBottom',
      title: 'OPTION_SHRINKING_BOTTOM',
    },
    {
      key: 'overpressAdditionalSpacing',
      title: 'OPTION_OVERPRESS_ADDITIONAL_SPACING',
    },
    {
      key: 'provisionalCrownShoulderSlope',
      title: 'OPTION_PROVISIONAL_CROWN_SHOULDER_SLOPE',
    },
    {
      key: 'provisionalCrownShoulderWidth',
      title: 'OPTION_PROVISIONAL_CROWN_SHOULDER_WIDTH',
    },
    {
      key: 'provisionalCrownTaperSlope',
      title: 'OPTION_PROVISIONAL_CROWN_TAPER_SLOPE',
    },
    {
      key: 'inlayThicknessRunOutDistance',
      title: 'OPTION_INLAY_THICKNESS_RUN_OUT_DISTANCE',
    },
    {
      key: 'partialSurveyDraftAngle',
      title: 'OPTION_PARTIAL_SURVEY_DRAFT_ANGLE',
    },
    {
      key: 'biteSplintBlockOutAngle',
      title: 'OPTION_BITE_SPLINT_BLOCK_OUT_ANGLE',
    },
    {
      key: 'biteSplintThicknessOcclusal',
      title: 'OPTION_BITE_SPLINT_THICKNESS_OCCLUSAL',
    },
    {
      key: 'biteSplintThicknessPeripheral',
      title: 'OPTION_BITE_SPLINT_THICKNESS_PERIPHERAL',
    },
    {
      key: 'virtualGingivaDesignBottomBlockOutOffset',
      title: 'OPTION_VIRTUAL_GINGIVA_DESIGN_BOTTOM_BLOCK_OUT_OFFSET',
    },
    {
      key: 'offsetSubStructureThickness',
      title: 'OPTION_OFFSET_SUBSTRUCTURE_THICKNESS',
    },
    {
      key: 'cementGapStart',
      title: 'OPTION_CEMENT_GAP_START',
    },
    {
      key: 'cementGapEnd',
      title: 'OPTION_CEMENT_GAP_END',
    },
    {
      key: 'crownAdditionalSpacingZ',
      title: 'OPTION_CROWN_ADDITIONAL_SPACING_Z',
    },
    {
      key: 'crownAdditionalSpacingX',
      title: 'OPTION_CROWN_ADDITIONAL_SPACING_X',
    },
    {
      key: 'crownAdditionalSpacingZOnTop',
      title: 'OPTION_CROWN_ADDITIONAL_SPACING_Z_ON_TOP',
    },
    {
      key: 'crownBorderHorizontalSize',
      title: 'OPTION_CROWN_BORDER_HORIZONTAL_SIZE',
    },
    {
      key: 'crownBorderAngledSize',
      title: 'OPTION_CROWN_BORDER_ANGLED_SIZE',
    },
    {
      key: 'crownBorderAngle',
      title: 'OPTION_CROWN_BORDER_ANGLE',
    },
    {
      key: 'crownBorderVerticalSize',
      title: 'OPTION_CROWN_BORDER_VERTICAL_SIZE',
    },
    {
      key: 'connectorArea',
      title: 'OPTION_CONNECTOR_AREA',
    },
    {
      key: 'overpressMinThickness',
      title: 'OPTION_OVERPRESS_MIN_THICKNESS',
    },
    {
      key: 'untouchableZoneNearPreparationMargin',
      title: 'OPTION_UNTOUCHABLE_ZONE_NEAR_PREPARATION_MARGIN',
    },
    {
      key: 'minThicknessNearPreparationMargin',
      title: 'OPTION_MIN_THICKNESS_NEAR_PREPARATION_MARGIN',
    },
    {
      key: 'minThicknessFullDistanceToPreparationMargin',
      title: 'OPTION_MIN_THICKNESS_FULL_DISTANCE_TO_PREPARATION_MARGIN',
    },
    {
      key: 'minThicknessGingivaDesign',
      title: 'OPTION_MIN_THICKNESS_GINGIVA_DESIGN',
    },
    {
      key: 'distanceToGingiva',
      title: 'OPTION_DISTANCE_TO_GINGIVA',
    },
    {
      key: 'distanceToAntagonist',
      title: 'OPTION_DISTANCE_TO_ANTAGONIST',
    },
    {
      key: 'distanceToNeighbor',
      title: 'OPTION_DISTANCE_TO_NEIGHBOR',
    },
    {
      key: 'connectorLingualOfContactAnterior',
      title: 'OPTION_CONNECTOR_LINGUAL_OF_CONTACT_ANTERIOR',
    },
    {
      key: 'prostheticBaseToothPocketOffset',
      title: 'OPTION_PROSTHETIC_BASE_TOOTH_POCKET_OFFSET',
    },
    {
      key: 'prostheticBaseMinThickness',
      title: 'OPTION_PROSTHETIC_BASE_MIN_THICKNESS',
    },
    {
      key: 'prostheticBaseThickness',
      title: 'OPTION_PROSTHETIC_BASE_THICKNESS',
    },
    {
      key: 'prostheticBaseCervicalThickness',
      title: 'OPTION_PROSTHETIC_BASE_CERVICAL_THICKNESS',
    },
    {
      key: 'connectorPullDownToVirtualGingiva',
      title: 'OPTION_CONNECTOR_PULL_DOWN_TO_VIRTUAL_GINGIVA',
    },
    {
      key: 'connectorWidth',
      title: 'OPTION_CONNECTOR_WIDTH',
    },
    {
      key: 'connectorHeight',
      title: 'OPTION_CONNECTOR_HEIGHT',
    },
    {
      key: 'partialCloneValue2',
      title: 'OPTION_PARTIAL_CLONE_VALUE2',
    },
    {
      key: 'partialMCBaseThickness',
      title: 'OPTION_PARTIAL_MC_BASE_THICKNESS',
    },
    {
      key: 'partialMCStippleThickness',
      title: 'OPTION_PARTIAL_MC_STIPPLE_THICKNESS',
    },
    {
      key: 'partialMeshHoleSize',
      title: 'OPTION_PARTIAL_MESH_HOLE_SIZE',
    },
    {
      key: 'partialMeshReliefHeight',
      title: 'OPTION_PARTIAL_MESH_RELIEF_HEIGHT',
    },
    {
      key: 'partialMeshThickness',
      title: 'OPTION_PARTIAL_MESH_THICKNESS',
    },
    {
      key: 'partialCloneValue3',
      title: 'OPTION_PARTIAL_CLONE_VALUE3',
    },
    {
      key: 'partialCloneValue1',
      title: 'OPTION_PARTIAL_CLONE_VALUE1',
    },
    {
      key: 'prostheticBaseMinThicknessUnderTeeth',
      title: 'OPTION_PROSTHETIC_BASE_MIN_THICKNESS_UNDER_TEETH',
    },
    {
      key: 'prostheticBaseToothPocketOffsetAnterior',
      title: 'OPTION_PROSTHETIC_BASE_TOOTH_POCKET_OFFSET_ANTERIOR',
    },
  ],
};

export const antagonistMapper: Record<number, number> = {
  // 상악
  11: 41,
  12: 42,
  13: 43,
  14: 44,
  15: 45,
  16: 46,
  17: 47,
  18: 48,
  21: 31,
  22: 32,
  23: 33,
  24: 34,
  25: 35,
  26: 36,
  27: 37,
  28: 38,
  // 하악
  41: 11,
  42: 12,
  43: 13,
  44: 14,
  45: 15,
  46: 16,
  47: 17,
  48: 18,
  31: 21,
  32: 22,
  33: 23,
  34: 24,
  35: 25,
  36: 26,
  37: 27,
  38: 28,
};

export const logoMapper: Record<string, string> = {
  sync_small: img_logo_S,
  sync_large: img_logo_L,
  marathon_small: img_marathon_S,
  marathon_large: img_marathon_L,
};
